/**
 * Cloudflare 认证适配器 — 封装 /api/auth
 * register / login / logout
 *
 * 注意：API_BASE 不使用模块级变量，避免 esbuild 惰性初始化时序问题，
 * 直接在请求时拼接（/api 相对当前域）。
 */
function post(path, body, token) {
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers['Authorization'] = 'Bearer ' + token;
  return fetch('/api' + path, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(body)
  }).then(function(res) {
    return res.json().catch(function() { return { error: '服务器响应异常' }; });
  });
}

export const CloudflareAuth = {
  register(email, password, name) {
    return post('/auth', { action: 'register', email, password, name });
  },
  login(email, password) {
    return post('/auth', { action: 'login', email, password });
  },
  logout(token) {
    return post('/auth', { action: 'logout' }, token);
  }
};
